import React from 'react';

const AnswerButton = (props) => {
    const buttonId = props.id+"_"+props.type
    return (
        <React.Fragment>
            <input className={"p-btn__answer-"+props.type} type="radio" value={props.type}
                   name={props.id} onClick={(e) => props.toggle(e.target)} id={buttonId} />
            <label for={buttonId} />
        </React.Fragment>
    );
};

export default AnswerButton;